import React from 'react';
import { dayMonth, moveState } from './lib/activityFormat';
import { stateChange } from './lib/documentHistory';

// moveState's tones as pill colours: shown green, partly amber, not yet clay.
const PILL_TONE = { ok: 'g', part: 'a', no: 'r' };

const StatePill = ({ value }) => {
  const state = moveState(value);
  return (
    <span className={`td-act-pill td-act-pill--${state ? PILL_TONE[state.tone] : 'o'}`}>
      {state ? state.text : 'Unknown'}
    </span>
  );
};

const CHANGE = {
  gain: { mark: '▲', text: 'Rose: ', tone: 'up' },
  loss: { mark: '▼', text: 'Fell: ', tone: 'down' },
};

const pointName = (point, word = 'Point') => `${word} ${point.number} (${dayMonth(point.at)})`;

/**
 * Every move of the element's catalogue, in `moves` order, at feedback
 * point `from` and, when given, at `to` (the later): "before → after"
 * pills, ▲ where the state rose and ▼ where it fell. Without `to`, one
 * pill per move. The three states are moveState's (shown, partly, not
 * yet); a move a point has no state for reads "Unknown", never the raw value.
 */
const MoveComparison = ({ moves, from, to }) => (
  <div className="td-act-vh__moves">
    <div className="td-act-vh__eyebrow">
      {to ? `${pointName(from)} → ${pointName(to, 'point')}` : pointName(from)}
    </div>
    {moves.map((m) => {
      const before = from.states?.[m.key];
      const after = to ? to.states?.[m.key] : null;
      const change = to ? CHANGE[stateChange(before, after)] : null;
      return (
        <div key={m.key} className="td-act-vh__move">
          <span>
            {change ? (
              <>
                <span className={`td-act-vh__change td-act-vh__change--${change.tone}`} aria-hidden="true">
                  {change.mark}
                </span>
                <span className="td-act-sr">{change.text}</span>
              </>
            ) : null}
            {m.label}
          </span>
          <span className="td-act-vh__states">
            <StatePill value={before} />
            {to ? (
              <>
                <span aria-hidden="true"> → </span>
                <span className="td-act-sr"> to </span>
                <StatePill value={after} />
              </>
            ) : null}
          </span>
        </div>
      );
    })}
  </div>
);

export default MoveComparison;
